// SideMenuRedirectEvent constant
export const SideMenuRedirectEvent: string = 'sidemenu:redirect';

// SideMenuRedirectEventData interface
export interface SideMenuRedirectEventData {
	displayName?: string;
}


// WEBPACK FOOTER //
// ./src/shared/side-menu-content/models/side-menu-redirect-events.ts